import { Component, OnInit, Optional, Inject } from '@angular/core';
import { FormGroup, Validators, AbstractControl, ValidatorFn, FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RoleService } from '../../services/role.service';
import { UserService } from '../../services/user.service';
import { User } from '../../models/user.model';
import { Role } from '../../models/role.model';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';


@Component({
  selector: 'app-role-user-assign-dialog',
  templateUrl: './role-user-assign-dialog.component.html',
  styleUrls: ['./role-user-assign-dialog.component.scss'],
})
export class RoleUserAssignDialogComponent implements OnInit {

  assignUserForm!: FormGroup;
  userInRoles!: User[];
  selectedRole!: Role;
  userNotInRoles!: User[];
  filteredOptions!: Observable<User[]>;


  constructor(public dialogRef: MatDialogRef<RoleUserAssignDialogComponent>,
    private fb: FormBuilder,
    private roleService: RoleService,
    private userService: UserService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.userInRoles = this.data?.users;
    this.selectedRole = this.data?.role;

    this.assignUserForm = this.fb.group({
      myControl: ['', [Validators.required, this.forbiddenNamesValidator()]]
    });


    this.roleService.getByRoleUser(this.selectedRole.name).subscribe(response => {
      this.userNotInRoles = response;

      const control = this.assignUserForm.get('myControl');

      if (!control) {
        console.error('FormControl "myControl" not found');
        return;
      }

      this.filteredOptions = control.valueChanges.pipe(
        startWith(''),
        map(value => typeof value === 'string' ? value : value?.userName),
        map(name => name ? this._filter(name) : this.userNotInRoles.slice())
      );
    });



  }

  displayFn(user: User): string {
    return user && user.userName ? user.userName : '';
  }

  private _filter(name: string): User[] {
    const filterValue = name.toLowerCase();

    return this.userNotInRoles.filter(option => option.userName.toLowerCase().indexOf(filterValue) === 0);
  }

  submit() {
    if (this.assignUserForm.valid) {
      const control = this.myControl;
      const userName = typeof control?.value === 'string'
        ? control?.value
        : control?.value?.userName ?? '';


      const roleFromUserName = this.userNotInRoles.find(x => x.userName?.toLowerCase() === (userName as string)?.toLowerCase());
      if (roleFromUserName) {
        this.userService.postUsersInRole(roleFromUserName.id, this.selectedRole.name).subscribe(response => {
          if (response) {
            this.dialogRef.close();
          }
        });
      }
    }
  }

  removeUser(user: User) {
    this.userService.postUsersInRole(user.id, this.selectedRole.name).subscribe(response => {
      if (response) {
        this.dialogRef.close();
      }
    });
  }

  onClose(): void {
    this.dialogRef.close();
  }


  public get myControl(): AbstractControl | null {
    return this.assignUserForm.get('myControl');
  }


  forbiddenNamesValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const index = this.userNotInRoles?.findIndex(role => {

        if (typeof control.value === 'string') {
          const result = (new RegExp('\^' + role?.userName?.toLowerCase() + '\$')).test((control.value as string)?.toLowerCase());
          return (result);
        }
        return (new RegExp('\^' + role?.userName?.toLowerCase() + '\$')).test((control.value.userName as string)?.toLowerCase());
      });
      return index < 0 ? { forbiddenNames: { value: control.value } } : null;
    };
  }
}
